import { webLightTheme } from '@fluentui/react-components';
import type { PartialTheme } from '@fluentui/react-components';

export default function getTheme(): PartialTheme {
  return {
    ...webLightTheme,
    borderRadiusMedium: '22px'
  };
}
